/**
 * Class hold businesslogic for single Store page
 */
export default class Store {

  /**
   * Page elements that are manipulated inside .store-page element
   */
  #elements = {}

  /**
   * @constructor
   * @param {HTMLElement} element component main element
   */
  constructor(element) {
    this.#elements.main = element;

    this.#findElements();
    this.#bindEventListeners();
  }

  /**
   * Find element from the main element
   */
  #findElements() {
    this.#elements.locationDepartmentFilterMultiselects = this.#elements.main.querySelectorAll('select.store-page-department-filter');
  }

  /**
   * Bind event listeners to components
   */
  #bindEventListeners() {
    this.#elements.locationDepartmentFilterMultiselects?.forEach( multiselectelement => {
      const context  = multiselectelement.closest('.store-page-department');
      const personCards = context.querySelectorAll('.store-page-department__personnel .person-card');

      window.multiselects[multiselectelement.id].addCallback({
        onValueChange: this.#departmentFilterChanges.bind(this, personCards)
      });
    });
  }

  /**
   * Filter personcard by what user have selected to multiselect element
   * @param {HTMLElement} personCards person card elements to be filtered by multiselect
   * @param {Multiselect} multiselect instance of multiselect
   */
  #departmentFilterChanges(personCards, multiselect) {
    const values = multiselect.getValue();

    personCards.forEach( card => {
      const brandUuids = card.dataset.brands.split(',');
      card.classList.toggle('hidden', values.length > 0 && !brandUuids.includes(values[0]) );
    });

  }

  /**
   * Initializes the whole thing in main.js or somewhere similar place.
   */
  static init() {
    document.querySelectorAll('.store-page').forEach( storeElement => new Store(storeElement));
  }
}

